/**
 * Set on a mutation's context by callers that already refetch the changelog
 * themselves, so the mutation-completed event does not trigger a second one.
 */
export const CHANGELOG_REFETCH_HANDLED_CONTEXT_KEY = "changelogRefetchHandled";
